import { Descriptions } from 'antd';
import { popup_props_transaltion } from '../../dictionaries/popup_props_translation.js';
import { addSeparators } from '../../utils/format-utils.js';

function RoadsInRegions({ data }) {
  const formatData = () => {
    return data.map((item, index) => {
      return {
        key: `road-item-${index}`,
        label: popup_props_transaltion[item.road_class],
        children: addSeparators((item.total_length_m / 1000).toFixed(1)),
      };
    });
  };

  return (
    <div>
      <div
        style={{
          fontSize: 14,
          fontWeight: 900,
          color: 'white',
          width: 'calc(100% - 42px)',
          marginBottom: 10,
        }}
      >
        Протяженность дорог, тыс. м
      </div>
      <Descriptions
        items={formatData()}
        column={1}
        size="small"
        layout="vertical"
      />
    </div>
  );
}

export default RoadsInRegions;
